module.exports = __webpack_public_path__ + "static/media/rest.f303d5f5.png";